import BlueriqEventhandler from './BlueriqEventhandler.js';

window.app.blueriq = new BlueriqEventhandler();
